<template>
  <div>
    <label :for="id">{{ label }}</label>
    <v-autocomplete
      :id="id"
      :height="height"
      v-bind="$attrs"
      v-on="$listeners"
      :value="value"
      rounded
      solo
      class="select-input"
      @input="$emit('update', $event)"
      append-icon="mdi-chevron-down"
      :menu-props="{ rounded: 'xl' }"
    />
  </div>
</template>
<script>
export default {
  name: "AutoComplete",
  props: {
    id: {
      Number,
      required: true
    },
    value: {
      String,
      required: true
    },
    label: {
      String,
      required: false
    },
    height: {
      Number,
      required: false
    }
  }
};
</script>
<style scoped>
.select-input.v-input /deep/ .v-input__slot {
  border: 1px solid #cecece;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px !important;
  display: flex !important;
  align-items: center !important;
  min-height: 40px !important;
}

label {
  color: #707070;
  font-family: "Lato", serif;
  font-weight: normal;
  font-size: 16px;
  text-align: left;
}

</style>
